/* ============
 * Mutations for the auth module
 * ============
 *
 * The mutations that are available on the
 * auth module.
 */

import Vue from 'vue'

import * as storageKeys from './storage-keys'

import {
  CHECK,
  REGISTER,
  LOGIN,
  LOGOUT,
  SET_PERMISSIONS
} from './mutation-types'

export default {
  [CHECK] (state, isAuthenticated) {
    if (isAuthenticated) {
      state.authenticated = true
      state.idToken = Vue.$storage.get(storageKeys.ID_TOKEN)
      state.accessToken = Vue.$storage.get(storageKeys.ACCESS_TOKEN)
      state.expiresAt = Vue.$storage.get(storageKeys.EXPIRES_AT)
      // Set authorization header
      Vue.$http.defaults.headers.common.Authorization = `Bearer ${Vue.$storage.get(storageKeys.ID_TOKEN)}`
    }
  },

  [REGISTER] () {
    //
  },

  [LOGIN] (state, data) {
    if (!data.idToken || !data.expiresIn || !data.accessToken) {
      throw Error('Login: Invalid data')
    }
    state.authenticated = true
    // Set the time that the access token will expire at
    const expiresAt = JSON.stringify(
      data.expiresIn * 1000 + new Date().getTime()
    )
    Vue.$storage.set(storageKeys.ID_TOKEN, data.idToken)
    state.idToken = data.idToken
    Vue.$storage.set(storageKeys.ACCESS_TOKEN, data.accessToken)
    state.accessToken = data.accessToken
    Vue.$storage.set(storageKeys.EXPIRES_AT, expiresAt)
    state.expiresAt = expiresAt
    Vue.$http.defaults.headers.common.Authorization = `Bearer ${Vue.$storage.get(storageKeys.ID_TOKEN)}`
  },

  [LOGOUT] (state) {
    state.authenticated = false
    state.accessToken = null
    state.idToken = null
    state.expiresAt = null
    state.permissions = ['any']
    Vue.$storage.clearAll()
    Vue.$http.defaults.headers.common.Authorization = ''
  },

  [SET_PERMISSIONS] (state, permissions) {
    if (Array.isArray(permissions)) {
      state.permissions = permissions
    } else if (permissions.indexOf('&') !== -1) {
      state.permissions = permissions.split('&')
    } else {
      state.permissions = [permissions]
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/store/modules/auth/mutations.js